import { render, staticRenderFns } from "./lingbuy.vue?vue&type=template&id=0887f467&scoped=true&"
import script from "./lingbuy.vue?vue&type=script&lang=js&"
export * from "./lingbuy.vue?vue&type=script&lang=js&"
import style0 from "./lingbuy.vue?vue&type=style&index=0&id=0887f467&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0887f467",
  null
  
)

export default component.exports